import React from 'react';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { PlanningPageType } from './PlanningPage';
import { useCurrentOperationalPeriod } from '../hooks/incidentHooks';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import classNames from 'classnames';

type PlanningStepperProps = {
  planningPhases: PlanningPageType[];
  currentPhase: number;
  updatePhase: (phase: number) => void;
};
const PlanningStepper: React.FC<PlanningStepperProps> = ({
  planningPhases,
  currentPhase,
  updatePhase,
}) => {
  const { data: currentPeriod } = useCurrentOperationalPeriod();

  const mostRecentlyCompletedPhase = currentPeriod?.phase_number_completed;
  const isPhaseANumber = typeof mostRecentlyCompletedPhase === 'number';
  const isPhaseCompleted = (phaseIndex: number) =>
    isPhaseANumber ? phaseIndex <= mostRecentlyCompletedPhase : false;

  const getStepStatus = (index: number): string => {
    if (isPhaseCompleted(index)) return 'Completed';
    if (index === currentPhase && !isPhaseCompleted(index))
      return 'In Progress';
    return 'Not Started';
  };

  return (
    <div className="planning-stepper">
      {planningPhases.map((phase, index) => (
        <React.Fragment key={index}>
          <div className="planning-stepper__row">
            <OverlayTrigger
              placement="right"
              overlay={(props) => (
                <Tooltip {...props}>
                  <div className="fw-bold">{phase.title}</div>
                  <div className="mt-1">{getStepStatus(index)}</div>
                </Tooltip>
              )}
            >
              <button
                type="button"
                className={classNames('planning-stepper__circle', {
                  active: index === currentPhase,
                  completed: isPhaseCompleted(index),
                })}
                onClick={() => updatePhase(index)}
                aria-label={`Go to phase ${index + 1}: ${phase.title}`}
              >
                {isPhaseCompleted(index) ? (
                  <SharedIcon iconName="check" size="sm" />
                ) : (
                  <span>{index + 1}</span>
                )}
              </button>
            </OverlayTrigger>
          </div>
          {index < planningPhases.length - 1 && (
            <div className="planning-stepper__connector" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default PlanningStepper;
